import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const ADD_CLIENT_PROVIDER_BY_NPI = "ADD_CLIENT_PROVIDER_BY_NPI";

export const service = async (npi) => {
  const options: object = {
    url: "/api/lookup/AddClientProviderByNPI/" + npi,
    method: "POST",
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(ADD_CLIENT_PROVIDER_BY_NPI, service, mock);
